import React, { ReactNode, MouseEvent, FunctionComponent } from 'react';

type CtaBoxHintProps = {
    children: ReactNode;
    onClick?: (event: MouseEvent) => void;
    qaRole?: string;
};

const CtaBoxHint: FunctionComponent<CtaBoxHintProps> = ({ children, onClick, qaRole }) => {
    // todo: check the children validation
    if (!children) {
        return null;
    }

    return (
        <div className="cta-box__hint" onClick={onClick} data-qa-role={qaRole || 'cta-box-hint'}>
            {children}
        </div>
    );
};

export default CtaBoxHint;
